// mobile-menu-trigger
(function() {

  var $trigger = $('.mobile-menu-trigger');
  var $page = $('.page');

  $trigger.on('click', function(event) {
    event.preventDefault();
    $page.toggleClass('page_mobile-menu_open');
  });

})();



// WEBPACK FOOTER //
// G:/RABOTA/satpharma/dev/source/modules/mobile-menu-trigger/mobile-menu-trigger.js